import { useEffect } from "react";

import { getText } from "shared/lib";
import {
  TreePropertyType,
  updateTreeProperty,
  type MeasurementTypeTreePropertyDescriptor,
  type SizeEstimateTreePropertyDescriptor,
  type TreeDescriptor,
} from "../lib";

import { RadioGroup, RadioGroupItem } from "shared/components";

export interface MeasurementTypeFieldProps {
  onChange: ((treeDescriptor: TreeDescriptor) => void) | undefined;
  treeDescriptor: TreeDescriptor;
}

export function MeasurementTypeField<
  T extends MeasurementTypeTreePropertyDescriptor,
>({ onChange, treeDescriptor }: MeasurementTypeFieldProps) {
  const measurementType = treeDescriptor.properties.get(
    TreePropertyType.measurement_type,
  ) as T | undefined;

  const handleChange = (value: string) => {
    let newTreeDescriptor = updateTreeProperty<T>(
      treeDescriptor,
      TreePropertyType.measurement_type,
      (draft) => {
        draft.value = value as T["value"];
      },
    );

    newTreeDescriptor = updateTreeProperty<SizeEstimateTreePropertyDescriptor>(
      newTreeDescriptor,
      TreePropertyType.size,
      (draft) => {
        draft.value = "";
      },
    );

    onChange?.(newTreeDescriptor);
  };

  useEffect(() => {
    if (!measurementType?.value) {
      handleChange("estimate");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [measurementType?.value]);

  return (
    <RadioGroup
      className="flex gap-2"
      onValueChange={handleChange}
      value={measurementType?.value}
    >
      <label className="text-bodyxs text-textPrimary flex items-center gap-1">
        <RadioGroupItem value="estimate" />
        {getText("Estimate only")}
      </label>

      <label className="text-bodyxs text-textPrimary flex items-center gap-1">
        <RadioGroupItem value="detailed" />
        {getText("Detailed measurements")}
      </label>
    </RadioGroup>
  );
}
